export const PieChartImg = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M29.3061 19.0179C30.4269 18.8581 31.35 19.7913 31.35 20.9234V31.1734C31.35 32.3056 32.2678 33.2234 33.4 33.2234H43.65C44.7822 33.2234 45.7154 34.1465 45.5555 35.2674C44.5634 42.2245 38.5814 47.5734 31.35 47.5734C23.4247 47.5734 17 41.1487 17 33.2234C17 25.9921 22.3489 20.01 29.3061 19.0179Z"
      fill="#DFECFF"
    />
    <path
      d="M35.05 31.2234C33.9178 31.2234 33 30.3056 33 29.1734V18.9234C33 17.7913 33.9231 16.8581 35.0439 17.0179C41.3335 17.9148 46.3086 22.89 47.2055 29.1795C47.3654 30.3004 46.4322 31.2234 45.3 31.2234H35.05Z"
      fill="#1E78FF"
    />
  </svg>
);
